
<div class="stage-child-status-wrapper">
	<div class="stage-child-status">
		<slot />
	</div>
	<div class="stage-card-expand-collapse-icon">
		<Icon name="chevron" size="small" :rotate="open ? 180 : 0" @click="handleClick($event)" />
	</div>
</div>
